module.exports = __webpack_public_path__ + "media/smart_sales/icon-3-7072690f.svg";